import { checkRequiredFields } from "./common";
import { getEmailErrorMessage } from "./emailValidation";
import {
  getPasswordErrorMessage,
  getConfirmedPasswordErrorMessage,
} from "./passwordValidation";

/**
 * Обязательные поля для формы юр. лица
 */
export const BUSINESS_REQUIRED_FIELDS = {
  companyName: "Наименование",
  inn: "ИНН",
  kpp: "КПП",
  phoneNumber: "Номер телефона",
  email: "Электронная почта",
  fio: "ФИО контактного лица",
  password: "Пароль",
  confirmedPassword: "Подтверждение пароля",
};

const fioPattern = new RegExp(
  "^[а-яА-ЯёЁa-zA-Z]+(-[а-яА-ЯёЁa-zA-Z]+)*( [а-яА-ЯёЁa-zA-Z]+(-[а-яА-ЯёЁa-zA-Z]+)*){1,2}$",
);

export const getFioErrorMessage = (value) => {
  if (!value) return "";
  return fioPattern.test(value.trim())
    ? ""
    : "Введите ФИО в корректном формате";
};

/**
 * Полная валидация формы юр. лица
 * @param {Object} formData - данные формы
 * @returns {Object} - объект с ошибками валидации
 */
export const validateBusinessForm = (formData) => {
  const requiredCheck = checkRequiredFields(formData, BUSINESS_REQUIRED_FIELDS);

  if (requiredCheck.isEmpty) {
    return {
      fieldErrors: requiredCheck.fieldErrors,
      messages: {
        email: "",
        password: "",
        confirmedPassword: "",
      },
      isValid: false,
      requiredFieldsError: requiredCheck.message,
    };
  }

  const fioError = getFioErrorMessage(formData.fio);
  const emailError = getEmailErrorMessage(formData.email);
  const passwordError = getPasswordErrorMessage(formData.password);
  const confirmedPasswordError = getConfirmedPasswordErrorMessage(
    formData.password,
    formData.confirmedPassword,
  );

  const messages = {
    fio: fioError || "",
    email: emailError || "",
    password: passwordError || "",
    confirmedPassword: confirmedPasswordError || "",
  };

  const hasErrors =
    fioError || emailError || passwordError || confirmedPasswordError;

  return {
    fieldErrors: {
      companyName: false,
      inn: false,
      kpp: false,
      phoneNumber: false,
      email: !!emailError,
      fio: !!fioError,
      password: !!passwordError,
      confirmedPassword: !!confirmedPasswordError,
    },
    messages,
    isValid: !hasErrors,
    requiredFieldsError: null,
  };
};

/**
 * Валидация полей при потере фокуса
 */
export const businessValidateOnBlur = {
  fio: (value) => getFioErrorMessage(value),
  email: (value) => getEmailErrorMessage(value),
  password: (value) => getPasswordErrorMessage(value),
  confirmedPassword: (value, formData) =>
    getConfirmedPasswordErrorMessage(formData?.password, value),
};

/**
 * Поля, которые нужно очищать при изменении
 */
export const businessClearOnChange = [
  "fio",
  "email",
  "password",
  "confirmedPassword",
];

/**
 * Преобразование данных формы юр. лица для отправки на сервер
 * @param {Object} formData - данные формы
 * @returns {Object} - данные для отправки
 */
export const prepareBusinessFormData = (formData, agreement) => {
  return {
    companyDetails: {
      companyName: formData.companyName,
      inn: formData.inn,
      kpp: formData.kpp,
    },
    phoneNumber: formData.phoneNumber,
    email: formData.email,
    fio: formData.fio.trim(),
    password: formData.password,
    agreementSOPD: {
      agreementStatus: agreement.checked,
      date: agreement.checkedAt,
    },
  };
};
